module.exports = __webpack_public_path__ + "static/img/7.a7ce0e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/oppo/7.png
// module id = 4A5Y
// module chunks = 0